export function Sparkline({ values }) {
  if (!values || values.length < 2) {
    return <span className="text-[10px] text-[var(--oim-text-dim)]">—</span>;
  }
  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = max - min || 1;
  const points = values.map((v, i) => `${(i / (values.length - 1)) * 60},${18 - ((v - min) / range) * 18}`).join(" ");
  const trendUp = values[values.length - 1] >= values[0];
  return (
    <svg width={60} height={18} data-testid="sparkline">
      <polyline points={points} fill="none" stroke={trendUp ? "var(--oim-green)" : "var(--oim-gold)"} strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
}
